var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg401({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 88V176.34H151.3V207.89H132.37V231.03H95.56V207.89H23V176.34L94.51 88H132.37ZM95.56 134.48L61.7 176.34H95.56V134.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.43 86.6666V236H386.083V124.64H360.483V86.6666H436.43Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg401);
export default __webpack_public_path__ + "static/media/img_401.48c78fd5ec002768187f7081e7721643.svg";
export { ForwardRef as ReactComponent };